import useFenderConnect from '@fenderdigital/custom-hooks/hooks/useFenderConnect';
import usePlayProfile, { ProfilePatch } from '@fenderdigital/custom-hooks/hooks/useProfile';
import usePlayUser from '@fenderdigital/custom-hooks/hooks/usePlayUser';

type PathUserData = {
  userID: string;
  firstName: string;
  profileFetched: boolean;
  pathID?: string;
  profileID?: string;
  updateProfile?: (id: string, attr: ProfilePatch) => Promise<void>;
  accessLevel?: string[] | null;
};

const usePathUserData = (update?: boolean): PathUserData => {
  const { userID, firstName } = useFenderConnect();
  const { profile, updateProfile, profileFetched } = usePlayProfile();
  const { accessLevel } = usePlayUser();
  const pathID = profile?.['play-path-id'];
  const profileID = profile?.id;
  return {
    userID,
    firstName,
    pathID,
    profileFetched,
    profileID,
    updateProfile: update ? updateProfile : undefined,
    accessLevel,
  };
};

export default usePathUserData;
